<template>
  <div class="carousel">
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="5000"
      fade
      background="#00b6f3"
      img-width="1024"
      img-height="192"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      
      <b-carousel-slide class="carousel_image" :img-src="require('../assets/img/banners/welcome2.jpg')"></b-carousel-slide>


      <router-link to="/games/mathmayhem">
        <b-carousel-slide class="carousel_image" :img-src="require('../assets/img/banners/mayhem.jpg')"></b-carousel-slide>
      </router-link>

      <router-link to="/games/treasurehunt">
        <b-carousel-slide class="carousel_image" :img-src="require('../assets/img/banners/pirate.jpg')"></b-carousel-slide>
      </router-link>

      <router-link to="/games/lemon">
        <b-carousel-slide class="carousel_image" :img-src="require('../assets/img/banners/lemonade.jpg')"></b-carousel-slide>
      </router-link>
    </b-carousel>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        slide: 0,
        sliding: null
      }
    },
    methods: {
      onSlideStart(slide) {
        console.log(slide);
        this.sliding = true
      },
      onSlideEnd(slide) {
        console.log(slide);
        this.sliding = false
      }
    }
  }
</script>

<style scoped>
.carousel {
  border-radius: 25px;
  overflow: hidden;
}

.carousel_image {
  border-radius: 25px;
  overflow: hidden;
}
</style>